var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 71.52 71.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5929",
    "data-name": "Path 5929",
    className: "cls-1",
    d: "M56.13,30.31a2.08,2.08,0,0,0-1.65-.77H47.13L37.35,17.75a2.1,2.1,0,0,0-2.94-.27,2.29,2.29,0,0,0-.27.27L24.36,29.53H17a2.09,2.09,0,0,0-1.64.82,2.06,2.06,0,0,0-.44,1.72L19.1,48.56a6.56,6.56,0,0,0,6.12,6H46.16a6.57,6.57,0,0,0,6.25-5.75l4.16-16.65A2.08,2.08,0,0,0,56.13,30.31Zm-20.38-8,6,7.2H29.77ZM48.24,47.9c-.23,1.39-1.11,2.39-2.09,2.41H25.34c-.94,0-1.81-1-2.09-2.58l-3.58-14H51.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5930",
    "data-name": "Path 5930",
    className: "cls-1",
    d: "M35.75,35.78A6.25,6.25,0,1,0,42,42a6.25,6.25,0,0,0-6.24-6.25Zm0,8.33A2.09,2.09,0,1,1,37.83,42a2.09,2.09,0,0,1-2.08,2.08Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.c6865a72cbad6caa5369d1d9bf151a9b.svg";
export { ForwardRef as ReactComponent };